import { Controller } from "@hotwired/stimulus"

import flatpickr from "flatpickr";
import rangePlugin from "flatpickr/dist/plugins/rangePlugin";

export default class extends Controller {

  connect() {
    // Avoid duplicate initialization
    if (this.element._flatpickr) return

    let timeEnabled = this.element.dataset.enableTime;
  
    this.datepickerOptions = {
      allowInput: true,
      altInput: true,
      altFormat: timeEnabled ? "d.m.Y H:i" : "d.m.Y",
      dateFormat: timeEnabled ? "d.m.Y H:i" : "d.m.Y",
      enableTime: timeEnabled,
      time_24hr: true,
      // null is used because search fields to show labels/placeholders
      defaultDate: this.element.dataset.defaultDate || null,
    };
    
    this.datepicker = flatpickr(this.element, this.datepickerOptions);
  }

  disconnect() {
    // Clean up when Turbo removes the element
    if (this.datepicker) {
      this.datepicker.destroy()
      this.datepicker = null
    }
  }
}
